var $9f921d880c5b9f0f$exports = {};
$9f921d880c5b9f0f$exports = {
    "collectionLabel": `Pasi\u{16B}lymai`
};


export {$9f921d880c5b9f0f$exports as default};
//# sourceMappingURL=lt-LT.module.js.map
